import facebook from '../assets/social/facebook.svg';
import instagram from '../assets/social/instagram.svg';
import pinterest from '../assets/social/pinterest.svg';
import snapchat from '../assets/social/snapchat.svg';
import tiktok from '../assets/social/tiktok.svg';
import x from '../assets/social/x.svg';
import youtube from '../assets/social/youtube.svg';

const ITEM = {
  'facebook': {
    image: facebook,
    label: 'Facebook',
  },
  'instagram': {
    image: instagram,
    label: 'Instagram',
  },
  'pinterest': {
    image: pinterest,
    label: 'Pinterest',
  },
  'snapchat': {
    image: snapchat,
    label: 'Snapchat',
  },
  'tiktok': {
    image: tiktok,
    label: 'TikTok',
  },
  'x': {
    image: x,
    label: 'X',
  },
  'youtube': {
    image: youtube,
    label: 'YouTube',
  },
};

const socials = {
  ITEM,
};

export default socials;